<template>
  <main-layout :title="tabStore?.activeTab?.title">
    <template #header-content>
      <tab-heads></tab-heads>
    </template>
    <template>
      <slot></slot>
    </template>
    <template #footer>
      <div id="footer-content"></div>
    </template>
  </main-layout>
</template>
<script lang="ts" setup>
import TabHeads from '@/components/core/tab-heads.vue'
import { useTabStore } from '@/stores/tab'
import MainLayout from './main-layout.vue'

defineOptions({
  name: 'MultiTabLayout',
  displayName: 'MultiTabLayout'
})
const tabStore = useTabStore()
</script>
<style scoped>
#footer-content {
  height: 20px;
}
.fade-transform-leave-active,
.fade-transform-enter-active {
  transition: all 0.3s;
}

.fade-transform-enter-from {
  opacity: 0;
  transform: translateX(-30px);
}

.fade-transform-leave-to {
  opacity: 0;
  transform: translateX(30px);
}
</style>
